<script>
  import { _ as t } from "svelte-i18n";

  import Title from "components/Title.svelte";
  import { currentLang } from "stores.js";

  export let programs;
</script>

{#if programs && programs.length > 0}
  <div class="program">
    <div class="content-container">
      <div class="header">
        <div class="item">
          <Title text={$t("event.program")} />
        </div>
      </div>

      {#each programs as program (program._key)}
        <div class="block">
          <div class="time">
            {program.time && program.time[$currentLang]
              ? program.time[$currentLang]
              : "-"}
          </div>
          <p>
            {#if program.title && program.title[$currentLang] !== null}
              <span class="subject">{program.title[$currentLang]}</span>
              <br />
            {/if}
            {#if program.description && program.description[$currentLang]}
              {#each program.description[$currentLang].split("\n") as line}
                {line}
                <br />
              {/each}
            {/if}
          </p>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .program {
    padding: 0 20px;
    max-width: 960px;
    margin: 50px auto 0;
  }

  .block {
    margin-bottom: 1.5rem;
  }

  .time {
    font-size: 13px;
    font-weight: 600;
    line-height: 24px;
  }

  p {
    margin: 0;
    font-size: 15px;
  }

  .subject {
    font-weight: 600;
  }

  @media only screen and (min-width: 600px) {
    .program {
      position: relative;
      margin-top: 6rem;
    }

    .block {
      display: grid;
      grid-template-columns: 1fr 5fr 1fr;
    }

    .time {
      text-align: right;
      padding-right: 20px;
    }

    p {
      font-size: 18px;
    }

    .header {
      display: grid;
      grid-template-columns: 1fr 5fr 1fr;
    }

    .item {
      grid-column-start: 2;
    }
  }
</style>
